import React, { useState } from "react";
import styles from "../styles/loginscreen.module.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";

const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(189,189,189,0.5)",
      borderWidth: "2px",
    },
    "&:hover fieldset": {
      borderColor: "rgba(189,189,189, 1)",
      borderWidth: "2px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(252, 142, 86, 1)",
      borderWidth: "2px",
    },
  },
};

const progressStyles = {
  color: "#fc8e56",
};

const LoginScreen = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const onSubmitHandler = (event) => {
    event.preventDefault();
    props.loginUser(email, password);
  };

  const onClickPrivacyPolicy = () => {
    navigate("/privacy-policy");
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.loginHeaderText}>
        {" "}
        Workers<span className={styles.boldText}>APP</span>{" "}
      </h1>
      <div className={styles.formContainer}>
        <h3 className={styles.signInText}> Sign In </h3>
        <form
          autoComplete="off"
          onSubmit={onSubmitHandler}
          className={styles.formStyles}
        >
          <div className={styles.inputContainer}>
            <label className={styles.label}>Email:</label>
            <TextField
              variant="outlined"
              sx={textFieldStyles}
              fullWidth
              placeholder="Enter Email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              name="email"
            />
          </div>
          <div className={styles.inputContainer}>
            <label className={styles.label}>Password:</label>
            <TextField
              variant="outlined"
              sx={textFieldStyles}
              type="password"
              fullWidth
              placeholder="Enter Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              name="password"
            />
          </div>
          <div className={styles.buttonContainer}>
            <Button
              variant="contained"
              type="submit"
              className={styles.submitButton}
              size="large"
              fullWidth
            >
              Sign In
            </Button>
          </div>
        </form>
        <div className={styles.buttonContainerPriv}>
          <Button variant="text" onClick={onClickPrivacyPolicy}>
            Privacy Policy
          </Button>
        </div>
        {props.isFetching ? <CircularProgress sx={progressStyles} /> : null}
      </div>
    </div>
  );
};

export default LoginScreen;
